<template>
  <span class="relevance-badge" :class="badgeClass">
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  rank: number; // 1-indexed
}>();

const isGold = computed(() => props.rank === 1);
const isSilver = computed(() => props.rank === 2);
const isBronze = computed(() => props.rank === 3);

const label = computed(() => (props.rank <= 3 ? '関連度 高' : '関連度 中'));

const badgeClass = computed(() => ({
  'relevance-badge--gold': isGold.value,
  'relevance-badge--silver': isSilver.value,
  'relevance-badge--bronze': isBronze.value,
  'relevance-badge--medium': props.rank >= 4,
}));
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.relevance-badge {
  display: inline-block;
  padding: 4px 8px;
  font-size: 0.75rem;
  font-weight: bold;
  border-radius: $border-radius-small;
  white-space: nowrap;

  &--gold {
    background: linear-gradient(90deg, #f5d061, #d4af37);
    color: #fff;
  }

  &--silver {
    background: linear-gradient(90deg, #c0c0c0, #8e8e8e);
    color: #fff;
  }

  &--bronze {
    background: linear-gradient(90deg, #cd7f32, #8b5a2b);
    color: #fff;
  }

  &--medium {
    background-color: $primary-color;
    color: #fff;
  }
}
</style>
